module.exports = __webpack_public_path__ + "static/media/steps-mobile.ac6410bf.svg";